const weekFortyFiveSummary =
    'All tasks planned for Week 45 are completed entirely to satisfaction. These are to plan, investigate, and ' +
    'design a realistic project proposal for the given timeframe, expertise, and availability of resources, present ' +
    'this in a written report and oral presentation, and implement the functionality for and deploy a React UI ' +
    'website to document the project and its progress.'
;

const weekFortySixSummary =
    'For week 46, all scheduled tasks are successfully completed, with the exception of the ongoing design, ' +
    'research, and experimental prototyping regarding draw functionality and GUI implementation using Python pip ' +
    'Pillow and PySimpleGUI libraries, respectively, which have each been extended into the following week(s) as' +
    ' estimated. The tasks completed this week involve setting up a testing framework and CI workflows for ' +
    'automated code convention and unit testing, implementing object models for port and vessel sketching, and ' +
    'image analysis and I/O utilities. Furthermore, the React UI is enhanced functionally and in aesthetic appeal. '
;

const weekFortySevenSummary =
    'For week 47, contributions to various aspects of the project development have been completed to plan. Concern' +
    'ing the GUI development, the opening window design is enhanced significantly, including a start on\n' +
    'the development for this and a drawing window prototype. Research on various alternative Python\n' +
    'GUI libraries other than PySimpleGUI is also conducted with Tkinter and/or potentially PyQT\n' +
    'selected as replacement(s) for improved feature support and aesthetic appeal. Aside from the GUI,\n' +
    'the model design is refactored along with numerous fixes to the code base in an improvement to\n' +
    'the test code coverage. As for non-development contributions, the group has given a mid-term\n' +
    'presentation of the project’s progress.'
;

const weekFortyEightSummary = 
    "For Week 48, continuing development of the GUI has been completed as planned, including the significant " +
    "enhancement to the opening window so that it more closely resembles the Figma design. There are yet many " +
    "details to add, however, for the GUI to be considered in its final stage of development. The drawing window " +
    "was also migrated from SimplePyGUI to Tkinter to align with the currently implemented framework for the rest " +
    "of the GUI. This also resolved the rendering issue when drawing lines. Other work done includes fixing and " +
    "improving test code coverage to be above 80% by adding test suites for the GUI development and implementing " +
    "save and load functionality of Python objects in preparation for implementing the saving of a project's state " +
    "and its integration with the GUI for the first end-to-end functional feature of the project.";

const weekFortyNineSummary = 'Regarding the frontend GUI development, much enhancement and refactoring has' +
    ' been completed, but not all of this is currently pushed to remote and merged to the `main` branch. What is ' +
    'merged to main for Week 49 is a complete drawing functionality framework integrated with the Tkinter GUI ' +
    'canvas, end-to-end functionality for saving and loading mooring plan projects and all respective data, ' +
    'including PIL Image object state, discovered bugs have been fixed, and test code coverage has been increased ' +
    'to 95\\%. More so, much time has been spent exploring options for manipulating PIL Image objects, such as ' +
    'moving and rotating. Furthermore, it has been researched that capabilities from openCV indicate that images, ' +
    'even external, could be read and objects extracted and manipulated, but no complete solution has been reached ' +
    'yet. Regarding the draft report, at least half of the sections have been authored almost to a finished standard. ';

const weekFiftySummary = "Significant improvements were made toward a basic prototype regarding overall " +
    "drawing functionality and the retrieving of user input and transferring it into an industry-standard PDF " +
    "format. In essence, the user can interact with various drawing interfaces: the vessel drawing window, the " +
    "docking drawing window, and the mooring planning drawing window. Within these interfaces, the user can both " +
    "create drawings and input data relevant to each context. The data and drawings entered in these windows " +
    "are then efficiently exported to a PDF by merging each into the mooring planning window. This PDF effectively" +
    " displays both the visual elements and the associated data as entered by the user, allowing for a " +
    "comprehensive representation of the input information. Aside from application development, a draft report " +
    "was authored.";

const weekFiftyOneSummary = "Christmas and New Year holidays";

const weekFiftyTwoSummary = "Christmas and New Year holidays";

const weekOneSummary = '';

const weeklySummaries = {
    45: weekFortyFiveSummary,
    46: weekFortySixSummary,
    47: weekFortySevenSummary,
    48: weekFortyEightSummary,
    49: weekFortyNineSummary,
    50: weekFiftySummary,
    51: weekFiftyOneSummary,
    52: weekFiftyTwoSummary,
    1: weekOneSummary,
};

export { weeklySummaries };
